export class RegisterViewModel {
  constructor(
    public email: string,
    public password: string,
    public confirmPassword: string,
    public preferredName?: string,
    public age?: number,
    public bmr?: number,
    public currentBodyWeight?: number,
    public goal?: string,
    public goalBodyWeight?: number,
    public height?: number,
    public activityLevel?: string,
    public recommendedDailyCalories?: number,
    public recommendedDailyCarb?: number,
    public recommendedDailyCarbPercent?: number,
    public recommendedDailyFat?: number,
    public recommendedDailyFatPercent?: number,
    public recommendedDailyProtein?: number,
    public recommendedDailyProteinPercent?: number,
    public sex?: string,
    public tdee?: number
  ) {}
}
